export interface Category {
    img?: string;
    product_name: string;
    price: string;
    status: string;
    category: string;
}

export const CATEGORY: Category[] = [
    {
        img: "assets/images/dashboard/product/1.jpg",
        product_name: "Headphones",
        price: "$20.00",
        status: "font-success",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/2.jpg',
        product_name: "Honor Mobile",
        price: "$462.00",
        status: "font-warning",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/3.jpg',
        product_name: "Samsung LED TV",
        price: "$652.00",
        status: "font-warning",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/4.jpg',
        product_name: "Motorola Bluetooth",
        price: "$25.00",
        status: "font-success",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/5.jpg',
        product_name: "Apple 6s",
        price: "$782.00",
        status: "font-danger",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/6.jpg',
        product_name: "Printer",
        price: "$4825.00",
        status: "font-warning",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/7.jpg',
        product_name: "Canon Camera",
        price: "$2461.00",
        status: "font-success",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/8.jpg',
        product_name: "High Quality Headphones",
        price: "$761.00",
        status: "font-danger",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/9.jpg',
        product_name: "Home Theater Speakers",
        price: "$672.00",
        status: "font-success",
        category: "Electronics",
    },
    {
        img: 'assets/images/dashboard/product/10.jpg',
        product_name: "Diamond Ring",
        price: "$237.00",
        status: "font-warning",
        category: "Jewellery",
    },
    {
        img: 'assets/images/dashboard/product/11.jpg',
        product_name: "Diamond Nacklace",
        price: "$3579.00",
        status: "font-warning",
        category: "Jewellery",
    },
    {
        img: 'assets/images/dashboard/product/12.jpg',
        product_name: "Diamond Earrings",
        price: "$3145.00",
        status: "font-success",
        category: "Jewellery",
    },
    {
        img: 'assets/images/dashboard/product/13.jpg',
        product_name: "Night lamp",
        price: "$84.00",
        status: "font-success",
        category: "furniture",
    },
    {
        img: 'assets/images/dashboard/product/14.jpg',
        product_name: "men's shoes",
        price: "$67.00",
        status: "font-danger",
        category: "shoes",
    },
    {
        img: 'assets/images/dashboard/product/15.jpg',
        product_name: "Ledi's red top",
        price: "$234.00",
        status: "font-success",
        category: "clothes",
    },
    {
        img: 'assets/images/dashboard/product/16.jpg',
        product_name: "latest ledis shoes",
        price: "$357.00",
        status: "font-danger",
        category: "shoes",
    },
    {
        img: 'assets/images/dashboard/product/17.jpg',
        product_name: "Woman one pis",
        price: "$682.00",
        status: "font-warning",
        category: "clothes",
    },
    {
        img: 'assets/images/dashboard/product/18.jpg',
        product_name: "Mouse",
        price: "$24.00",
        status: "font-success",
        category: "electronics",
    },
    {
        img: 'assets/images/dashboard/product/19.jpg',
        product_name: "Coffee maker",
        price: "$9721.00",
        status: "font-warning",
        category: "electronics",
    },
    {
        img: 'assets/images/dashboard/product/20.jpg',
        product_name: "Diamond Nacklace",
        price: "$3579.00",
        status: "font-success",
        category: "Jewellery",
    },

];
